import React, {useState, useContext} from "react";
import {useQueryClient} from "react-query";
import __ from "lodash";
import {Stack} from "@mui/material";
import {IconButton, Tooltip} from '@material-ui/core';
import {HighlightOff, Search} from '@material-ui/icons';
import SystemContext from "../../../SystemContext";
import {AwbNumber} from "../../../controls";


const marginLeft = 10;
const defaultEditProps = {
  style:{fontSize: "0.875rem"}
};
const formatChars={
  "A": "[A-Za-z0-9]",
  "9": "[0-9]",
}

const emptySearch = {
  awbPrefix: "",
  awbSerial: "",
}


const AwbSelector = (props) => {
  const queryClient = useQueryClient();
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const [search, setSearch] = useState(props.searchCriteria ?? emptySearch);

  const handleSearchChange = () => {
    debugger;
    let searchCriteria = {...search};
    if (__.has (searchCriteria, "awbPrefix") && searchCriteria.awbPrefix !== "" && __.has (searchCriteria, "awbSerial") && searchCriteria.awbSerial !== "")
    if (eventBus) {
      eventBus.trigger('AwbTracking.search', searchCriteria);
    }
  }

  const handleClearSelections = () => {
    setSearch(emptySearch);
    if (eventBus) {
      eventBus.trigger('AwbTracking.clearSearch', {});
    }
  }

  return (
    <div style={{padding: "10px 20px", textAlign: "left", width: "calc(100% - 20px)"}}>
      <div style={{display: "inline-flex"}}>
        <div style={{width: 120, display: "inherit", marginLeft: marginLeft,}}>
          <AwbNumber
            label="Air Waybill"
            inputLabelProps={{shrink: true}}
            fullWidth
            prefix={search.awbPrefix}
            serial={search.awbSerial}
            //inputProps={defaultEditProps}
            onChange={(value, props) => {
              setSearch({...search, awbPrefix: value.prefix, awbSerial: value.serial});
            }}
          />
        </div>
        <div style={{display: "inherit", marginLeft: marginLeft}}>
          <Stack direction="row" alignItems="center" spacing={0}>
            <IconButton onClick={()=>{handleSearchChange()}} >
              <Tooltip title={"Click to retrieve Air Waybill tracking data"}>
                <Search style={{height: 24, width: 24, }} color="primary"/>
              </Tooltip>
            </IconButton>
            <IconButton onClick={()=>{handleClearSelections()}}>
              <Tooltip title={"Click to clear selection"}>
                <HighlightOff style={{height: 24, width: 24, }} color="primary"/>
              </Tooltip>
            </IconButton>
          </Stack>
        </div>
      </div>
      <div style={{display: "inline-block"}}></div>
    </div>
  )
}

export default AwbSelector;
